import { type Context, createContext, useContext } from 'react';

export const RefreshedFilterButtonContext: Context<boolean> = createContext(false);

export const useIsRefreshedFilterButton = (): boolean => useContext(RefreshedFilterButtonContext);
